module.exports = __webpack_public_path__ + "img/whats-new-1_cn.1a9211d.jpg";